import { ComponentChildren } from "preact";
import Header from "./Header.tsx";
import Footer from "./Footer.tsx";
import { HeroSection } from "./sections/HeroSection.tsx";
import { GageAI } from "./GageAI.tsx";
import { AI_CHAT_ENABLED } from "./ai-feature.ts";
import { Section } from "./sections/Section.tsx";
import { ContactForm } from "./ContactForm.tsx";

export function Layout(
  { children, vars }: { children: ComponentChildren, vars: Record<string, unknown> },
) {
  const meta = vars.meta as Record<string, unknown>;
  const showBlogContactForm = vars.showBlogContactForm === true;

  return (
    <>
      <main>
        <Header />
        <div class="scrollable">
          <div class="for-spacing"></div>
          <div class="children">
            {meta.title && meta.image && (
              <HeroSection
                title={meta.title + ""}
                src={meta.image + ""}
                subtitle={meta.subtitle ? meta.subtitle + "" : undefined}
                ctaText={meta.ctaText ? meta.ctaText + "" : undefined}
                ctaHref={meta.ctaHref ? meta.ctaHref + "" : undefined}
              />
            )}
            <div class="children-top"></div>
            {children}
            {showBlogContactForm && (
              <Section>
                <ContactForm>
                  <h2>Contact us for<br />a consultation.</h2>
                </ContactForm>
              </Section>
            )}
            <div class="children-bottom"></div>
          </div>
          <Footer />
        </div>
        {AI_CHAT_ENABLED && <GageAI />}
      </main>
    </>
  );
}
